// The backend deletes a user's tokens on logout, password change or reset, so
// a token saved in localStorage can stop working at any time. When an API call
// answers 401 we drop the dead session and send the user to sign in, rather
// than leaving them on screens that render as if they had no data.

export const SESSION_EXPIRED_EVENT = "sit:session-expired";

// Requests already in flight fail too, and their pages toast "failed to load".
// Those are noise next to "your session has expired", so error toasts are
// muted briefly (see showToast.error).
const MUTE_ERRORS_MS = 3000;
let expiredAt = 0;

export const sessionJustExpired = () => Date.now() - expiredAt < MUTE_ERRORS_MS;

export const clearSession = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("user");
};

/** Called by the API client when the saved token is rejected. */
export const expireSession = () => {
  if (!localStorage.getItem("authToken")) return;
  clearSession();
  expiredAt = Date.now();
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
};
